/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { BidLevelingDecisionsControllerListQueryResponse, BidLevelingDecisionsControllerListQueryParams, BidLevelingDecisionsControllerList401, BidLevelingDecisionsControllerList403 } from "../../models/bidsController/BidLevelingDecisionsControllerList";

function getBidLevelingDecisionsControllerListUrl() {
  const res = { method: 'GET', url: `/api/v1/bid-leveling-decisions` as const }  
  return res
}

/**
 * @summary List a trade's decision log, newest first
 * {@link /api/v1/bid-leveling-decisions}
 */
export async function bidLevelingDecisionsControllerList(params: BidLevelingDecisionsControllerListQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<BidLevelingDecisionsControllerListQueryResponse, ResponseErrorConfig<BidLevelingDecisionsControllerList401 | BidLevelingDecisionsControllerList403>, unknown>({ method : "GET", url : getBidLevelingDecisionsControllerListUrl().url.toString(), params, ... requestConfig })  
  return res.data
}